import {
  FiPhone,
  FiMapPin,
  FiClock,
  FiMessageSquare,
  FiShield,
  FiCheckCircle
} from "react-icons/fi";

import { motion } from "framer-motion";
import "./Footer.css";


function Footer() {


return (

<footer className="footer">


<motion.div

className="footer-emergency"

initial={{
opacity:0,
y:30
}}

whileInView={{
opacity:1,
y:0
}}

viewport={{
once:true
}}

>


<div>

<span>
24/7 EMERGENCY LOCKSMITH
</span>


<h2>
Locked Out? We Can Help Right Now.
</h2>


<p>
Fast response across Cape Town for homes,
vehicles, and businesses.
</p>

</div>



<a href="tel:+27604971899">

<FiPhone/>

Call Now

</a>


</motion.div>





<div className="container footer-wrapper">



<div className="footer-brand">

<h3>
Cape Town Locksmith
</h3>


<p>

Professional locksmith services providing
emergency assistance, security upgrades,
and reliable protection solutions.

</p>



<div className="footer-trust">


<div>
<FiCheckCircle/>
24/7 Service
</div>


<div>
<FiCheckCircle/>
Trusted Experts
</div>


<div>
<FiCheckCircle/>
Cape Town Wide
</div>


</div>



</div>





<div className="footer-links">

<h4>
Services
</h4>


<a href="#services">
Emergency Lockouts
</a>


<a href="#services">
Lock Repairs
</a>


<a href="#services">
Key Cutting
</a>


<a href="#services">
Security Upgrades
</a>


<a href="#services">
Commercial Locksmith
</a>


</div>







<div className="footer-contact">

<h4>
Contact
</h4>



<a href="tel:+27604971899">

<FiPhone/>
+27604971899

</a>



<a 
href="https://wa.me/27604971899"
target="_blank"
rel="noreferrer"
>

<FiMessageSquare/>

WhatsApp Us

</a>



<p>

<FiMapPin/>

Serving Cape Town

</p>



<p>

<FiClock/>

Available 24/7

</p>


<p>

<FiShield/>

Licensed & Insured

</p>



</div>



</div>





<div className="footer-bottom">

<p>

© {new Date().getFullYear()}
Nashie Locksmiths.
All rights reserved.

</p>


</div>



</footer>


)

}


export default Footer;